import { UseMutationOptions, useMutation } from "@tanstack/react-query";

import { useClient, useQueryClient } from "../../ClientContext";
import { PortalClientError } from "../../types";

const useRecalculateUserPoints = (
  id: string,
  options?: UseMutationOptions<void, PortalClientError>
) => {
  const client = useClient();
  const queryClient = useQueryClient();
  return useMutation<void, PortalClientError>(
    () => client.post(`/users/${id}/recalculate_points`),
    {
      ...options,
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries(["users", id]);
        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
export default useRecalculateUserPoints;
